module.exports = __webpack_public_path__ + "static/media/take3Aces_1.c25f556a.svg";